import { parse, stringify } from 'qs'
import actionTypes from '../actions/actionTypes'
import browserHistory from 'helpers/history'
import redirectTo, {getFormattedUrl} from 'helpers/redirection'
import errorCodes from 'helpers/enums/errorCodes'
import config from 'config'
import {
	makeLibraryURL,
	getLandingRoute,
	getSearchRoute,
	getLockedContentRoute,
	getUpgradeRoute,
	getAuthorRoute,
	getCheckoutRoute,
	addParamToUrl,
	getInteractiveVideoCreateRoute,
	getInteractiveVideoCreateRouteBase,
	getVideoPickerByRoute,
	getVideoEditByRoute,
} from 'helpers/urlHandler'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import libraryTypes from 'helpers/enums/libraryTypes'
import viewTypes from 'helpers/enums/viewTypes'
import { navigateToLibrary } from 'helpers/navigation/navigateToLibrary'
import findFilter from 'helpers/filter/findFilter'
import {
	uiSelectors,
	storeSelectors,
} from 'redux/selectors'
import { userShouldBeRedirectedToMyLibrary } from 'redux/selectors/user'
import currentViewSelector from 'redux/selectors/ui/currentViewSelector'
import platformTypes from 'helpers/enums/platformTypes'
import lessonSources from 'helpers/enums/lessonSources'
import cancelSlideSelector from 'redux/selectors/slide/cancel_slide_selector'
import actionToSlideTypes from 'helpers/enums/actionToSlideTypes'
import slideTypes from 'helpers/enums/slideTypes'
import filterTabs from 'helpers/enums/filters/tabs'
import { detectMobileScreen } from 'helpers/device'
import bindersAllowedSelector from 'redux/selectors/binders/binder_allowed_selector'
import shouldHideStoreSelector from 'redux/selectors/user/user_store_access_selector'
import onboardingActivityDataSelector from 'redux/selectors/onboarding_activity/onboarding_activity_data_selector'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import userAcademicLevelSelector from 'redux/selectors/user/academic_level_selector'
import { localize } from 'helpers/translator/localize'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'
import routeTypes from 'helpers/enums/routeTypes'
import standAloneActivityTypes from 'helpers/enums/standAloneActivityTypes'
import iVideoCreationCurrentActivitySelector from 'redux/selectors/interactive_video_creation/current_activity_selector'
import { identitySelector, getBreakpointUidFromBreakpointActivityUid, videoStatusSelector } from 'redux/selectors/interactive_video_creation'
import mixpanel from 'helpers/mixpanel'
import sessionTypes from 'helpers/enums/sessionTypes'
import activityCreationRouteTypes from 'helpers/enums/interactiveVideoCreation/activityCreationRouteTypes'
import lessonStatusTypes from 'helpers/enums/lessonStatusTypes'
import lessonTypes from 'helpers/enums/lessonTypes'
import isAssetCreatedSelector from 'redux/selectors/assets/is_asset_created_selector'
import isAssetUnlinkedSelector from 'redux/selectors/assets/is_asset_unlinked_selector'
import featureFlagsHashSelector from 'redux/selectors/feature_flags/feature_flags_hash_selector'
import cartDownloadProductSelector from 'redux/selectors/cart/cart_download_product_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import { getFlag } from 'helpers/featureFlags/provider'
import videoStatusTypes from 'helpers/enums/interactiveVideoCreation/videoStatusTypes'
import currentViewMetricsSelector from 'redux/selectors/lessons/current_view_metrics_selector'
import qsStudentJoinParamsSelector from 'redux/selectors/qs/qs_student_join_params_selector'
import creationRouteTypeFormatter from 'helpers/creationRouteTypeFormatter'
import variants from 'helpers/enums/noResultsVariants'

const handleNotSupportedDevices = store => {
	const ui = uiSelectors.uiDataSelector(store.getState())
	if (detectMobileScreen(ui.height, ui.width)) {
		if (ui.currentView === viewTypes.STORE_LANDING) {
			window.location.href = config.app + 'notAccessible'
		} else {
			browserHistory.push('/not-supported/')
		}
	}
}

const handleUnauthorizedBinderAccess = store => {
	const ui = uiSelectors.uiDataSelector(store.getState())
	const bindersAllowed = bindersAllowedSelector(store.getState())
	if (ui.currentView === viewTypes.SUB_PLANS && !bindersAllowed) {
		window.location.href = getUpgradeRoute()
	}
}

const handleUnauthorizedStoreAccess = store => {
	const blockedViews = [
		viewTypes.STORE_LANDING,
		viewTypes.STORE_SEARCH,
		viewTypes.STORE_FOLDER,
		viewTypes.STORE_PREVIEW,
	]
	const state = store.getState()
	const ui = uiSelectors.uiDataSelector(state)
	const shouldHideStore = shouldHideStoreSelector(state)
	if (shouldHideStore && blockedViews.includes(ui.currentView)) {
		browserHistory.push(getLockedContentRoute())
	}
}

function handleOnboardingSkip(action) {
	if (action.fromStore) {
		browserHistory.push(getLandingRoute())
	} else {
		const url = config.app + 'library'
		redirectTo(url)
	}
}

function handleNotLoggedUser(action) {
	if (action.error_code === 99) {
		window.location.href = config.maintenance
		return false
	}
	return true
}

function handleUserUpgradeSelected(upgrade_data, button_data) {
	if (button_data.action === '1') {
		const path = config.www + 'get-gold'
		window.location.href = path
	}
}

function handleMyLibraryDeletedLesson(action, store) {
	const state = store.getState()
	const lesson = action.lesson
	if (state.myLibraryPreview.entityUID === lesson.data.entityUID) {
		browserHistory.push('/library')
	}

}

function handleMyLibraryCreateLesson(action, store) {
	const state = store.getState()
	let createLessonPath = `${config.ct_alt}actions/presentation/new.php?startFromScratch=true&appFrom=APP_HTML`
	if (state.myLibrary.folderUID !== '0' && state.myLibrary.folderUID !== 0) {
		createLessonPath += `&parentFolder=${state.myLibrary.folderUID}`
	}
	window.location.href = createLessonPath
}

function handleGoogleSlideCreationSuccess(action) {
	if (!action.isInIframe) {
		window.location.href = action.lessonData.webViewLink
	}
}


function handleEditLesson(action) {
	if (action.lessonData.state === lessonStatusTypes.NOT_PUBLISHED
		&& action.lessonData.type !== lessonTypes.VIDEO) {
		const sourceInfo = action.lessonData.sourceInfo

		let redirectTo = `${config.ct_alt}presentation.php?id=${action.lessonData.id}&edit_from_library=${Date.now()}`

		if (sourceInfo.type === lessonSources.GOOGLE_SLIDES) {
			redirectTo = `${config.googleSlides.presentation}${sourceInfo.payload.id}`
		}

		window.location.href = redirectTo
	}
}

function handleVerifyUrlRedirection(action) {
	if (action.data && action.data.redirectUrl) {
		window.location.href = action.data.redirectUrl
		return false
	}
	return true
}

function handleVerifyCorporateAccount(action) {
	if (action.data && action.data.verifyCorporateAccount) {
		browserHistory.push('/verify-account', { userEmail: action.userEmail })
	}
}

function handleUpdateLibraryParams(action, store) {
	const state = store.getState()
	const lti = state.lti
	const folderUID = action.folderUID ? action.folderUID : state.myLibrary.folderUID
	let ltiParams
	if (formatLibraryType(lti) !== libraryTypes.REGULAR) {
		ltiParams = {
			canvas: lti.canvas,
			ltiForwardUrl: lti.ltiForwardUrl,
			ltiToken: lti.ltiToken,
			teams: lti.teams,
		}
	}
	browserHistory.push(makeLibraryURL({query: action.query, orderField: action.orderField, lti: ltiParams}, folderUID))
}

function handleLtiCanvasSaved(action) {
	if (!action.teams) {
		if (!action.payload.forwardUrl) {
			//we need to use replace, dont change
			window.location.replace(config.app + 'presentation?pin=' + action.payload.pincode)
		} else if (!action.payload.postParams
			&& action.payload.notSupported
			&& !action.payload.canBeFixed) {
			browserHistory.push('/lti/display')
		} else {
			//we need to use replace, dont change
			window.location.replace(action.payload.forwardUrl)
		}
	}
}

function handleMyLibraryHomeworkUpgradeActionSelected(action) {
	if (action.button.action === '1') {
		const redirectUrl = config.www + 'get-gold'
		if (action.isIframeView) {
			window.open(redirectUrl)
		} else {
			window.location.href = redirectUrl
		}
	}
}

function handleSearchRedirect(action, store) {
	const state = store.getState()
	let searchUrl = ''
	let queryUrl = ''

	// Retrocompatibility with OLD ANGULAR STORE, when delete the feature flags 'STORE_LANDING_NEW_UI' & 'STORE_SEARCH_ROUTE_NEW_UI' delete this if
	const currentView = state.ui.currentView
	if (![
		viewTypes.STORE_LANDING,
		viewTypes.STORE_SEARCH,
		viewTypes.STORE_FOLDER,
		viewTypes.STORE_PREVIEW,
		viewTypes.INTERACTIVE_VIDEO_CREATE,
		viewTypes.VIDEO_STANDALONE_CREATE,
		viewTypes.VIDEO_CREATE,
		viewTypes.TIME_TO_CLIMB_CREATION,
		viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION,
		viewTypes.DRAW_IT_CREATION,
		viewTypes.DRAW_IT_STANDALONE_CREATION,
		viewTypes.MATCHING_PAIRS_CREATION,
		viewTypes.MATCHING_PAIRS_STANDALONE_CREATION,
	].includes(currentView)) {
		return
	}

	const storeData = storeSelectors.storeSearchSelector(state)
	if (!storeData.canSearchFilters) {
		return
	}

	const categories = state.store.currentTab === filterTabs.REGULAR_TAB
		? state.store.categories
		: state.store.standard

	const friendlyText = state.store.confirmedFilters.map(entityUID => findFilter(categories, entityUID))
		.reduce( (accumulator, item) => accumulator + item.friendlyText + '-', '')

	const confirmedFilters = state.store.confirmedFilters.map(item => {
		// '--C' Appear on filters when 'All Strands' is selected
		if (item.lastIndexOf('--C') !== -1) {
			return item.substr(0, item.lastIndexOf('--C'))
		} else {
			return item
		}
	})

	const filters = confirmedFilters.join(',')
	if (filters) {
		searchUrl = `${friendlyText}C${filters}`
	}

	if (state.store.query) {
		queryUrl = addParamToUrl(queryUrl, 'q', state.store.query)
	}

	const selectedType = storeData.lessonTypeSelectedFilter.join('&')
	if (selectedType) {
		queryUrl = addParamToUrl(queryUrl, 't', selectedType)
	}

	if ([
		lessonTypes.VIDEO,
		lessonTypes.TIME_TO_CLIMB,
		lessonTypes.DRAW_IT,
		lessonTypes.MATCHING_PAIRS,
	].includes(storeData.fixedLessonType)) {
		const searchQuery = state.store.query
		const searchFilters = action.type === actionTypes.STORE_FILTERS_CLEAR
			? ''
			: filters
		handleSearchUpdate({...action, search: searchQuery, filters: searchFilters})
	} else if (queryUrl || searchUrl) {
		browserHistory.push(getSearchRoute(searchUrl, queryUrl))
	} else {
		browserHistory.push(`/${getLandingRoute()}`)
	}
}

function reload() {
	location.reload()
}

function returnToUrl(store) {
	const state = store.getState()
	window.location.href = state.qs.returnUrl
}

function handleCancelGame(store, action) {
	const state = store.getState()
	if (!state.game.isModified) {
		handleCancelSlide(store, action)
	}
}

function handleGoogleSlidesSaveAndGoToNearpod(store) {
	const state = store.getState()
	const source = lessonSources.GOOGLE_SLIDES

	const redirectUrl = `${config.ct}redirection/presentationExternalSave?source=${source}&externalId=${state.qs.presentationId}`
	window.open(redirectUrl)
}

function handleRedirectToSubPlans(store) {
	handleRedirect(store, 'binders/list')
}

function handleRedirect(store, url) {
	const ui = uiSelectors.uiDataSelector(store.getState())
	if (!ui.platform || ui.platform === platformTypes.EXTERNAL) {
		window.location.href = `${config.www}${url}`
	} else {
		browserHistory.push(`/${url}`)
	}
}

function handleRedirectStore(store, viewType) {
	switch (viewType) {
		case viewTypes.APP_CHECKOUT:
			window.location.href = getCheckoutRoute()
			break
		case viewTypes.STORE_LANDING:
			handleRedirect(store, getLandingRoute())
			break
	}
}

function handleRedirectByUrl(url) {
	if (url.includes('.')) {
		window.location.href = url
	} else {
		browserHistory.push(`/${url}`)
	}
}

function handleOnboardingActivityView(store) {
	const state = store.getState()
	const currentView = currentViewSelector(state)
	const lessonData = onboardingActivityDataSelector(state)
	if (currentView === viewTypes.ONBOARDING_ACTIVITY && lessonData.isDeleted === '0') {
		browserHistory.push('/library')
	}
}

function handlePersonalizedNewsRedirect(store) {
	const state = store.getState()
	const userAcademicLevel = userAcademicLevelSelector(state)
	if (userAcademicLevel === academicLevelTypes.HIGHER_ED) {
		window.open(`${config.www}nearpod-for-higher-ed`, '_blank')
	} else {
		window.open(`${config.www}?ph=1`, '_blank')
	}
}


function handleRedirectReport() {
	window.location.href = `${config.ct_alt}reports.php`
}

const handleCancelSlide = (store, action) => {
	const slideType = actionToSlideTypes[action.type]
	const cancelSlideData = cancelSlideSelector(store.getState(), { slideType })
	if (cancelSlideData.cancelUrl) {
		window.location.href = cancelSlideData.cancelUrl
	} else if (slideType === slideTypes.SLIDE_TYPE_ID_VIDEO) {
		browserHistory.push('/library/')
	} else {
		window.history.back()
	}
}

const handleRedirectToSchoolFreeTrial = (userType, store) => {
	const ui = uiSelectors.uiDataSelector(store.getState())
	if (ui.currentView === viewTypes.LIBRARY) {
		browserHistory.push(`/school-trial/${userType}/1`)
	} else {
		window.location.href = config.www + `school-trial/${userType}/1`
	}
}

const handleNudgeMyAdminSelected = (store, action) => {
	const mailBody = encodeURIComponent(localize('flocabulary_limit_reached_overlay_email_body_2'))
	const mailSubject = encodeURIComponent(localize('flocabulary_limit_reached_overlay_email_subject'))
	window.open('mailto:?subject=' + mailSubject + '&body=' + mailBody, '_blank')
	handleCancelSlide(store, action)
}

const handleRedirectToStoreNewUrl = store => {
	const storeNewRouteRedirectionData = storeSelectors.storeNewRouteRedirection(store.getState())
	if (storeNewRouteRedirectionData.shouldRedirect) {
		let urlPath = window.location.pathname
		urlPath = urlPath.replace(
			storeNewRouteRedirectionData.from,
			storeNewRouteRedirectionData.to
		)
		browserHistory.push(urlPath)
	}
}

const handleRedirectSaveCustomActivity = store => {
	const state = store.getState()
	const activityOrigin = activityOriginSelector(state)

	if (activityOrigin === presentationOriginTypes.REGULAR) {
		returnToUrl(store)
	}
}

const handleRedirectSaveActivity = (store, action) => {
	const state = store.getState()
	const activityOrigin = activityOriginSelector(state)

	if (activityOrigin === presentationOriginTypes.REGULAR) {
		window.location.href = action.redirectUrl
	}
}

const handleVideoRouteInitialize = store => {
	if (userShouldBeRedirectedToMyLibrary(store.getState())) {
		browserHistory.push(routeTypes.LIBRARY)
	}
}

const handleSelectedVideoSuccessRedirection = store => {
	const interactiveVideoIdentityData = identitySelector(store.getState())
	const uid = interactiveVideoIdentityData.uid
	const params = {
		jwt: interactiveVideoIdentityData.jwt,
	}
	browserHistory.push(
		getInteractiveVideoCreateRoute(uid, params)
	)
}

const handleFrontOfClassroomRedirection = payload => {
	let redirectUrl = payload.redirect_url
	redirectUrl += '&device_uid=tabc'
	redirectUrl += '&role=t'
	redirectUrl += '&pm=0'
	redirectUrl += `&session_uid=${payload.session_uid}`
	window.location.href = redirectUrl
}

const handleInteractiveVideoCreation = action => {
	window.location.href = action.payload.redirectUrl
}

const handleOpenQuickLaunchOeqCreate = store => {
	if (store.getState().ui.currentView === viewTypes.REPORTS) {
		window.location.href =
			`${config.www}quick-launch/oeq/create/`
	} else {
		browserHistory.push('/quick-launch/oeq/create/')
	}
}

const handleOpenQuickLaunchDrawItCreate = store => {
	if (store.getState().ui.currentView === viewTypes.REPORTS) {
		window.location.href =
			`${config.www}quick-launch/draw-it/create/`
	} else {
		browserHistory.push('/quick-launch/draw-it/create/')
	}
}

const handleOpenQuickLaunchTimerCreate = store => {
	if (store.getState().ui.currentView === viewTypes.REPORTS) {
		window.location.href =
			`${config.www}library/?newQuickLaunchActivity=${standAloneActivityTypes.TIMER}`
	}
}

const handleOpenQuickLaunchCollaborateCreate = store => {
	if (store.getState().ui.currentView === viewTypes.REPORTS) {
		window.location.href =
			`${config.www}library/?newQuickLaunchActivity=${standAloneActivityTypes.COLLABORATE}`
	}
}

const interactiveVideoCreationActivityCreateRedirection = (store, action) => {
	const state = store.getState()
	const interactiveVideoIdentityData = identitySelector(state)
	const uid = interactiveVideoIdentityData.uid
	const jwt = interactiveVideoIdentityData.jwt
	const activityRoute = activityCreationRouteTypes[action.activityType]
	const currentView = currentViewSelector(state)
	const baseRoute = getInteractiveVideoCreateRouteBase(uid, currentView)
	const params = {
		jwt,
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
		breakpointUid: action.breakpointUid,
	}

	browserHistory.push(
		`${baseRoute}/${activityRoute}/create/`
		+ stringify(params, { addQueryPrefix: true })
	)
}

const interactiveVideoCreationActivityEditRedirection = (store, action) => {
	const state = store.getState()
	const interactiveVideoIdentityData = identitySelector(state)
	const uid = interactiveVideoIdentityData.uid
	const jwt = interactiveVideoIdentityData.jwt
	const activityRoute = activityCreationRouteTypes[action.activityType]
	const breakpointUid = getBreakpointUidFromBreakpointActivityUid(action.breakpointActivityUid)(state)
	const currentView = currentViewSelector(state)
	const baseRoute = getInteractiveVideoCreateRouteBase(uid, currentView)
	const params = {
		jwt,
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
		breakpointUid,
		breakpointActivityUid: action.breakpointActivityUid,
		isEdition: 1,
	}

	browserHistory.push(
		`${baseRoute}/${activityRoute}/create/${action.newActivityUid}`
		+ stringify(params, { addQueryPrefix: true })
	)
}

const interactiveVideoCreationRouteUpdate = store => {
	const state = store.getState()
	const interactiveVideoIdentityData =
		identitySelector(
			store.getState()
		)
	const interactiveVideoUid = interactiveVideoIdentityData.uid
	const jwt = interactiveVideoIdentityData.jwt

	const currentActivityData =
		iVideoCreationCurrentActivitySelector(
			store.getState()
		)
	const activityUid = currentActivityData.activity.activityUid
	const breakpointUid =
		currentActivityData.interactiveVideoActivity.breakpointUid
	const breakpointActivityUid =
		currentActivityData.interactiveVideoActivity.breakpointActivityUid

	const slideTypeRoute = activityCreationRouteTypes[currentActivityData.type]
	const currentView = currentViewSelector(state)
	const baseRoute = getInteractiveVideoCreateRouteBase(interactiveVideoUid, currentView)
	const params = {
		jwt,
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
		breakpointUid,
		breakpointActivityUid,
	}

	browserHistory.replace(
		`${baseRoute}/${slideTypeRoute}/create/${activityUid}`
		+ stringify(params, { addQueryPrefix: true })
	)
}

const handleActivityUpdated = (store, action) => {
	const params = parse(location.search.substr(1))
	const state = store.getState()
	const currentView = currentViewSelector(state)
	const creationRoute = creationRouteTypeFormatter(currentView)
	browserHistory.replace(
		`/${creationRoute}/create/${action.data.entityUid}`
		+ stringify(params, { addQueryPrefix: true })
	)
}

const handleCustomActivityUpdated = (store, action) => {
	const state = store.getState()
	const currentView = currentViewSelector(state)
	const creationRoute = creationRouteTypeFormatter(currentView)
	const params = parse(location.search.substr(1))
	params.jwt = action.data.jwt
	if (action.data && action.data.returnUrl) {
		params.returnUrl = action.data.returnUrl
	}
	browserHistory.replace(
		`/${creationRoute}/create/${action.data.entityUid}`
		+ stringify(params, { addQueryPrefix: true })
	)
}

const interactiveVideoCreationRedirectToMediaView = store => {
	const state = store.getState()
	const interactiveVideoIdentityData = identitySelector(state)
	const uid = interactiveVideoIdentityData.uid
	const jwt = interactiveVideoIdentityData.jwt
	const currentView = currentViewSelector(state)
	const params = {
		jwt,
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
	}

	browserHistory.push(
		getInteractiveVideoCreateRoute(uid, params, currentView)
	)
}

const handleNavigationMenuMainManage = (store, action) => {
	const ui = uiSelectors.uiDataSelector(store.getState())
	if (ui.platform && ui.platform === platformTypes.WEB) {
		window.location.href = action.redirectUrl
	}
}

const handleResumeSession = async (store, action) => {
	const sessionTypeLabels = {
		[sessionTypes.LIVE_SESSION]: 'Live Session',
		[sessionTypes.HOMEWORK]: 'Student Paced',
	}
	const params = {
		type: sessionTypeLabels[action.sessionType],
	}
	await mixpanel.track('Lesson Resumed', params, true)
	const state = store.getState()
	const currentView = currentViewMetricsSelector(state)
	window.location.href = `${config.app}command?puid=${action.presentation_uid}`
		+ `&sid=${action.session_uid}&origin=${encodeURIComponent(currentView)}`
		+ `${!!action.hasZoom ? '&withZoom=1' : ''}`
}

const handleResumeLiveSession = (store, action) => {
	if (!action.hasMultiplePins) {
		const state = store.getState()
		const params = {
			presentation_uid: action.presentationUid,
			sessionType: sessionTypes.LIVE_SESSION,
			session_uid: state.myLibrary.liveCodes.session_uid,
			hasZoom: action.hasZoom,
		}
		handleResumeSession(store, params)
	}
}

const handleGoogleSlidesInitializeError = (store, action) => {
	if (action.error.error_code === errorCodes.ADDON_NOT_SUPPORTED) {
		browserHistory.push('/google-slides-addon-error')
	}
}

const handleUserCookieFailed = (store, action) => {
	// We use location and not the currentView because we need to check this before even the
	// view loads and the uiReducer updates the current view
	if (action.error.error_code === errorCodes.COOKIES_FAILED
		&& (
			location.pathname === '/google-slides/main'
			|| location.search.includes('/google-slides/main')
			|| location.search.includes(encodeURIComponent('/google-slides/main'))
		)
	) {
		browserHistory.push('/cookie-error/?referer='
			+ `${encodeURIComponent(location.pathname + location.search)}`)
	}
}

const handleUserCookieLearnMore = () => {
	window.open('https://nearpod.zendesk.com/hc/en-us/articles/360043626771', '_blank')
}

const handleUserCookieRetry = () => {
	const params = parse(location.search.substr(1))
	if (params.referer) {
		browserHistory.push(decodeURIComponent(params.referer))
	} else {
		browserHistory.push('/login')
	}
}

const handleReadOnlyNavigation = action => {
	if (action.link.url) {
		window.open(getFormattedUrl(action.link.url), '_blank')
	}
}

const handleUserSchoolProfileSave = () => {
	browserHistory.push('/library/')
}

const handleVideoPickerTabSelected = (store, action) => {
	const state = store.getState()
	const ui = uiSelectors.uiDataSelector(state)
	const identityData = identitySelector(state)
	const params = {
		jwt: identityData.jwt,
		q: state.qs.q,
		f: state.qs.filters && state.qs.filters.join(','),
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
	}
	const url = getVideoPickerByRoute(ui.currentView, action.picker, identityData.uid, params)
	browserHistory.push(url)
}

const handleSearchUpdate = action => {
	const params = parse(location.search.substr(1))
	params.q = action.search
	params.f = action.filters
	browserHistory.push(`${location.pathname}${stringify(params, { addQueryPrefix: true })}`)
}

const handleInteractiveVideoCreationToolRedirection = store => {
	const state = store.getState()
	const interactiveVideoIdentityData = identitySelector(state)
	const uid = interactiveVideoIdentityData.uid
	const jwt = interactiveVideoIdentityData.jwt
	const currentView = currentViewSelector(state)
	const hashFF = featureFlagsHashSelector(state)
	const videoStreamlineFF = getFlag(featureFlagsTypes.VIDEO_LESSON_STREAMLINE)
	const videoRedirect = [viewTypes.VIDEO_CREATE, viewTypes.VIDEO_STANDALONE_CREATE].includes(currentView)
	const interVidRedirect = (currentView === viewTypes.INTERACTIVE_VIDEO_CREATE
		&& hashFF && videoStreamlineFF)
	const params = {
		jwt,
		cancelUrl: state.qs.cancelUrl,
		returnUrl: state.qs.returnUrl,
	}

	if (videoRedirect || interVidRedirect) {
		if (isAssetCreatedSelector(state) && isAssetUnlinkedSelector(state)) {
			if (state.qs.picker) {
				params.picker = state.qs.picker
				params.q = state.qs.q
				params.f = state.qs.filters && state.qs.filters.join(',')
			}
			const url = getVideoEditByRoute(currentView, uid, params)
			browserHistory.push(url)
		} else {
			if (state.qs.picker) {
				params.q = state.qs.q
				params.f = state.qs.filters && state.qs.filters.join(',')
			}
			// @TODO: check where place you were before get here to avoid wrong / unnecessary redirection
			const url = getVideoPickerByRoute(currentView, state.qs.picker || 'store', uid, params)
			browserHistory.push(url)
		}
	}
}

const handlePaywallsUpgradeSelected = (store, action) => {
	const state = store.getState()
	const cartData = cartDownloadProductSelector(state)
	if (cartData.shouldOfferUpgrade) {
		handleRedirectByUrl(
			`${config.www}upgrade-account?utm_source=${action.upgradeSource}&utm_medium=Popup&utm_campaign=Upgrade`
		)
	} else if (!action.intercomIsEnabled && !cartData.intercomIO) {
		window.open('mailto:support@nearpod.com?subject=Help!%20My%20Gold%20account%20is%20out%20of%20Storage!')
	}
}

const interactiveVideoCreationCancelRedirect = store => {
	const state = store.getState()

	if (!isAssetCreatedSelector(state)) {
		browserHistory.push('/library')
	}
}

const handleInteractiveVideoSettingsSaveRedirection = store => {
	const videoStatus = videoStatusSelector(store.getState())
	if (videoStatus === videoStatusTypes.SAVING) {
		browserHistory.push('/library/')
	}
}

const videoEmbedInSlidesRedirect = (store, action) => {
	const data = identitySelector(store.getState())
	const jwt = data.jwt
	const params = {jwt}
	const url = `${config.api}presentation/custom_slides/${action.externalUid}/convert_to_slides`
    + stringify(params, { addQueryPrefix: true })
	window.location.href = url
}

const handleUserCannyIdentifySuccess = boardType => {
	window.open(`${config.canny.url}${boardType}`, '_blank')
}

const redirectToRedeem = code => {
	window.open(`${config.www}redeem?redeemCode=${code}`)
}

const handlePaywallsEditGoogleSlidesUnauthorized = () => {
	window.open('https://nearpod.zendesk.com/hc/en-us/articles/360051730851', '_blank')
}

const handleSessionPreviewRedirect = action => {
	let session_uid
	let pincode
	if (action.payload.hasPreviousSession && action.payload.multiplePins) {
		session_uid = action.payload.activePins[0].session_uid
		pincode = action.payload.activePins[0].pincode
	} else {
		session_uid = action.payload.session_uid
		pincode = action.payload.pincode
	}
	let redirectUrl = `/session-preview/${action.presentation_uid}/${session_uid}`
	if (pincode) {
		redirectUrl += `/${pincode}`
	}
	browserHistory.push(redirectUrl)
}

const handleStudentJoinRedirect = (store, action) => {
	const studentJoinParams = qsStudentJoinParamsSelector(store.getState())
	let redirectUrl = `${config.app}presentation?pin=${action.value}`
	if (studentJoinParams.isSessionPreview) {
		redirectUrl += '&isSessionPreview=1'
	}
	window.location.href = redirectUrl
}

const handleUserMustAcceptTermsAndConditions = store => {
	const user = store.getState().user
	if (user.logged && user.data.mustAcceptTermsAndConditions === '1' && window.location.pathname !== '/new_terms_and_conditions/') {
		const qs = window.location.pathname.includes('/google-slides/') ? `?referer=${encodeURIComponent(window.location.pathname + window.location.search)}` : ''
		window.location.href = '/new_terms_and_conditions/' + qs
	}
}

const handleUserAcceptedTermsAndConditions = store => {
	const qs = store.getState().qs
	const referer = qs.referer
	const redirectUrl = referer ? decodeURIComponent(referer) : '/library/'

	browserHistory.push(redirectUrl)
}

const redirectMiddleware = store => next => action => {
	let should_propagate_action = true
	switch (action.type) {
		case actionTypes.MY_LIBRARY_SESSION_FETCHED:
		case actionTypes.QUICK_LAUNCH_LAUNCH_LESSON_SUCCESS:
			if (action.payload.hasPreviousSession !== true) {
				should_propagate_action = false
				const state = store.getState()
				const currentView = currentViewMetricsSelector(state)
				window.location.href = `${config.app}command?puid=${action.presentation_uid}`
					+ `&sid=${action.payload.session_uid}&origin=${encodeURIComponent(currentView)}`
					+ `${action.hasZoom ? '&withZoom=1' : ''}`
			}
			break
		case actionTypes.USER_IS_NOT_LOGGED:
			should_propagate_action = handleNotLoggedUser(action)
			break
		case actionTypes.USER_IS_LOGGED:
		case actionTypes.USER_IS_AUTOLOGGED:
			should_propagate_action = handleVerifyUrlRedirection(action)
			break
	}
	if (!should_propagate_action) {
		return
	}
	next(action)
	switch (action.type) {
		case actionTypes.USER_DATA_FETCHED:
			handleUserMustAcceptTermsAndConditions(store)
			break
		case actionTypes.USER_ACCEPT_TERMS_AND_CONDITIONS_SUCCESS:
			handleUserAcceptedTermsAndConditions(store)
			break
		case actionTypes.MATCHING_PAIRS_CT_SAVE_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_PAIR_SAVE_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_SAVE_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_ADD_NEW_CARD_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_SAVE_ACTIVITY_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_DELETE_PAIR_ERROR:
		case actionTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRMED:
		case actionTypes.COOKIES_DISABLED_CONFIRM_RETRY:
			reload()
			break
		case actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_VALIDATE_ERROR:
			if (!([errorCodes.EXCEED_MAX_PRESENTATION_SIZE, errorCodes.EXCEED_MAX_USER_STORAGE, errorCodes.EXCEED_MAX_FILE_SIZE].includes(action.error_code))) {
				reload()
			}
			break
		case actionTypes.POLL_SAVE_POLL_SUCCESS:
		case actionTypes.STOREFRONT_VISITOR_INITIALIZE_ERROR:
		case actionTypes.STOREFRONT_OWNER_INITIALIZE_ERROR:
		case actionTypes.PRIVATE_LIBRARY_PREVIEW_INITIALIZE_ERROR:
		case actionTypes.TOPBAR_REDIRECT:
		case actionTypes.PRIVATE_LIBRARY_LEARN_MORE_PACKAGES:
		case actionTypes.PRIVATE_LIBRARY_UNLOCK_SAMPLE_LESSONS:
		case actionTypes.ADMIN_ONBOARDING_SCHOOL_CONFIRM_DO_REDIRECT_TO_MY_LIBRARY:
		case actionTypes.ADMIN_ONBOARDING_CONGRATS_TO_NEARPOD_LIBRARY_REDIRECT:
		case actionTypes.ADMIN_ONBOARDING_VALIDATE_STEP_WHITELIST_ERROR:
		case actionTypes.ADMIN_ONBOARDING_VALIDATE_STEP_FAILED:
		case actionTypes.DESMOS_SAVE_DESMOS_SUCCESS:
		case actionTypes.FLOCABULARY_SAVE_SUCCESS:
		case actionTypes.MY_LIBRARY_IMMERSIVE_READER_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_PUBLISH_SUCCESS:
		case actionTypes.SIDEBAR_NAVIGATE_TO_SELECTED:
			handleRedirectByUrl(action.redirectUrl)
			break
		case actionTypes.PAIR_IMAGE_PICK_UPLOAD_ERROR:
		case actionTypes.QUIZ_UPLOADER_UPLOAD_ERROR:
			if (action.error.error_code === -1) {
				reload()
			}
			break
		case actionTypes.QUIZ_QUESTION_SAVE_ERROR:
			if (!([errorCodes.EXCEED_MAX_PRESENTATION_SIZE, errorCodes.EXCEED_MAX_USER_STORAGE, errorCodes.EXCEED_MAX_CHARS].includes(action.error.error_code))) {
				reload()
			}
			break
		case actionTypes.QUIZ_QUESTION_UPDATE_ERROR:
			if (action.error.error_code !== errorCodes.EXCEED_MAX_CHARS) {
				reload()
			}
			break
		case actionTypes.QUIZ_DELETE_QUESTION_ERROR:
		case actionTypes.QUIZ_DROP_QUESTION_ERROR:
		case actionTypes.QUIZ_TITLE_SAVE_ERROR:
			reload()
			break
		case actionTypes.DESMOS_CANCEL_DESMOS:
		case actionTypes.FLIPGRID_CREATION_TOOL_CANCEL:
		case actionTypes.DRAW_IT_CANCEL_DRAW_IT_CONFIRMED:
		case actionTypes.QUIZ_CANCEL_QUIZ_CONFIRMED:
		case actionTypes.POLL_CANCEL_POLL_CONFIRMED:
		case actionTypes.OEQ_CANCEL_OEQ_CONFIRMED:
		case actionTypes.MATCHING_PAIRS_CT_CANCEL_MP_CONFIRMED:
		case actionTypes.GAME_CANCEL_CONFIRMED:
		case actionTypes.FLOCABULARY_CLOSE_SELECTED:
		case actionTypes.FLOCABULARY_LIMIT_REACHED_OVERLAY_DISMISS_SELECTED:
		case actionTypes.VIDEO_CANCEL_CONFIRMED:
			handleCancelSlide(store, action)
			break
		case actionTypes.ONBOARDING_SKIP_REDIRECT:
			handleOnboardingSkip(action)
			break
		case actionTypes.PRIVATE_LIBRARY_CURRENT_APPLY_REDIRECT_SEARCH:
			browserHistory.push('/libraries/' + action.libraryUID)
			break
		case actionTypes.PRIVATE_LIBRARY_MANAGE_LIBRARY_REDIRECT:
			window.location.href = config.ct + 'admin/privateLibrary.php'
			break
		case actionTypes.PRIVATE_LIBRARY_VIEW_LIBRARY_REDIRECT:
			browserHistory.push('/libraries/' + action.libraryId)
			break
		case actionTypes.PRIVATE_LIBRARY_REDIRECT_TO_LIBRARY:
			browserHistory.push('/admin/libraries/' + action.libraryUID)
			break
		case actionTypes.MY_LIBRARY_RESUME_ACTIVE_LIVE_SESSION:
			handleResumeSession(store, action)
			break
		case actionTypes.MY_LIBRARY_PREVIEW_LESSON:
			browserHistory.push(`/library/preview/lesson-L${action.lessonId}`)
			break
		case actionTypes.MY_LIBRARY_PREVIEW_DATA_FETCHED:
			window.document.title = action.response.result.data.name
			break
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_SUCCESS:
			if (action.folder === '0') {
				browserHistory.push('/library/' + action.response.payload.entityUID)
			}
			break
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_SUCCESS:
			browserHistory.push('/library/' + action.folder)
			break
		case actionTypes.MY_LIBRARY_VISIT_PRIVATE_LIBRARY:
			browserHistory.push('/libraries/' + action.library_uid)
			break
		case actionTypes.MY_LIBRARY_GO_TO_REPORTS:
			window.location.href = config.ct_alt + 'reports.php?loadPresentationId=' + action.id
			break
		case actionTypes.MY_LIBRARY_EXPORT_TO_GOOGLE_DRIVE:
			window.open(config.ct + 'googlePicker.php?isUpload=true&presentationId=' + action.lessonid, '_blank', {width: 400, height: 300})
			break
		case actionTypes.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE_FETCHED:
			window.location.assign(action.pdfUrl)
			break
		case actionTypes.USER_UPGRADE_ACTION_SELECTED:
			handleUserUpgradeSelected(action.upgrade_data, action.button_data)
			break

		case actionTypes.MY_LIBRARY_EDIT_LESSON_SUCCESS:
			window.location.href = action.redirectUrl
			break
		case actionTypes.MY_LIBRARY_DUPLICATE_LESSON_SUCCESS:
			window.location.href = action.redirectUrl
			break
		case actionTypes.MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED:
			handleMyLibraryHomeworkUpgradeActionSelected(action)
			break
		case actionTypes.MY_LIBRARY_DELETE_LESSON_SUCCESS:
			handleMyLibraryDeletedLesson(action, store)
			break
		case actionTypes.MY_LIBRARY_PREVIEW_EXIT:
			window.document.title = 'Nearpod'
			break
		case actionTypes.MY_LIBRARY_CREATE_LESSON:
		case actionTypes.MY_LIBRARY_CREATE_LESSON_THUMBNAIL:
		case actionTypes.MAIN_TOPBAR_CREATE_LESSON:
		case actionTypes.ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SUCCESS:
			handleMyLibraryCreateLesson(action, store)
			break
		case actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED_SUCCESS:
			handleLtiCanvasSaved(action)
			break
		case actionTypes.MY_LIBRARY_SEARCH_LESSONS:
		case actionTypes.MY_LIBRARY_FOLDER_SELECTED:
		case actionTypes.MY_LIBRARY_DELETE_FOLDER_RESPONSE_SUCCESS:
			handleUpdateLibraryParams(action, store)
			break
		case actionTypes.STORE_LANDING_INITIALIZE:
			handleNotSupportedDevices(store)
			handleUnauthorizedStoreAccess(store)
			break
		case actionTypes.STORE_BASE_ROUTE_INITIALIZE:
			handleRedirectToStoreNewUrl(store)
			handleUnauthorizedStoreAccess(store)
			break
		case actionTypes.USER_EXTRA_DATA:
		case actionTypes.STORE_SEARCH_ROUTE_INITIALIZE:
		case actionTypes.STORE_FOLDER_INITIALIZE:
		case actionTypes.STORE_PREVIEW_INITIALIZE:
			handleUnauthorizedStoreAccess(store)
			break
		case actionTypes.FEATURE_FLAGS_GET_SUCCESS:
			handleRedirectToStoreNewUrl(store)
			handleUnauthorizedStoreAccess(store)
			handleVideoRouteInitialize(store)
			handleInteractiveVideoCreationToolRedirection(store)
			break
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SELECT_ROUTE:
			handleVideoRouteInitialize(store)
			break
		case actionTypes.INTERACTIVE_VIDEO_UPDATE_VIDEO_SUCCESS:
			handleSelectedVideoSuccessRedirection(store)
			break
		case actionTypes.PRIVATE_LIBRARY_LESSONS_ACCESS_DENIED:
			if (action.error.error_code === errorCodes.OPERATION_NOT_PERMITED) {
				window.location.href = action.redirectUrl
			}
			break
		case actionTypes.ADMIN_ONBOARDING_TRANSITION_STEP:
			browserHistory.push('/school-trial/' + action.redirectUrl)
			break
		case actionTypes.LOGIN_SSO_REDIRECT_METRICS_SUCCESS:
			if (!action.isInIframe) {
				window.location.href = action.redirectUrl
			}
			break
		case actionTypes.STORE_NPP_THUMBNAIL_SELECTED:
			// Review this when removing STORE_NEW_ROUTES
			if (action.redirectUrl.includes('/libraries/')
				|| action.redirectUrl.includes('/t/')
				|| action.redirectUrl.includes('/s/')) {
				action.event.preventDefault()
				handleRedirectByUrl(action.redirectUrl)
			}
			break
		case actionTypes.STORE_WIDGET_ITEM_SELECTED:
			// ToDo: When Preview (folder, lesson, bundle) will be migrated to react here an internal redirection will be need
			window.location.href = action.redirectUrl
			break
		case actionTypes.DM_STORAGE_EXPERIMENT_DOUBLE_STORAGE:
			window.location.href = config.www + 'dm-storage/refer-contact'
			break
		case actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS_SUCCESS:
			browserHistory.push(getLandingRoute())
			break
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES:
			window.location.href = config.www + 'school-trial/share-teachers'
			break
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT:
			window.location.href = config.www + 'school-trial/refer-contact'
			break
		case actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND_SUCCESS:
		case actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE_SUCCESS:
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_REDIRECT:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND_SUCCESS:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE_SUCCESS:
			navigateToLibrary()
			break
		case actionTypes.CART_SAVE:
			if (action.libraryUID) {
				window.location.href = config.www + 'signup/?referer=/public-library/' + action.libraryUID + '/preview/' + action.friendlyUrl
			} else {
				window.location.href = config.www + 'signup/?referer=' + action.friendlyUrl
			}
			break
		case actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_UPGRADE:
			window.location.href = config.www + 'upgrade-to-gold'
			break
		case actionTypes.MY_LIBRARY_PAYWALL_REMINDER_UPGRADE:
			window.location.href = config.www + 'get-gold'
			break
		case actionTypes.PRIVATE_LIBRARY_FOLDER_SELECTED:
			browserHistory.push(`${action.isAdmin ? '/admin' : ''}/libraries/${action.libraryUID}/folder/${action.folderId}`)
			break
		case actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM_SUCCESS:
			handleRedirectToSchoolFreeTrial('admin', store)
			break
		case actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_USER_ONBOARDING_OVERLAY_CONFIRM_SUCCESS:
			handleRedirectToSchoolFreeTrial('teacher', store)
			break
		case actionTypes.MY_LIBRARY_SUBS_OVERLAY_LEARN_MORE:
			browserHistory.push('/binders/list/')
			break
		case actionTypes.SIGNUP_SEND_EMAIL_FORM_SUCCESS:
			handleVerifyCorporateAccount(action)
			break
		case actionTypes.GAME_SAVE_SUCCESS:
		case actionTypes.FLIPGRID_CREATION_TOOL_SAVE_SUCCESS:
		case actionTypes.VIDEO_SAVE_SUCCESS:
			handleRedirectSaveCustomActivity(store)
			break
		case actionTypes.GAME_CANCEL:
			handleCancelGame(store, action)
			break
		case actionTypes.MY_LIBRARY_TIME_TO_CLIMB_SUCCESS:
			window.location.href = getAuthorRoute(action.timeToClimbAuthor)
			break
		case actionTypes.STORE_QUERY_SEARCH:
		case actionTypes.STORE_FILTERS_SEARCH:
		case actionTypes.STORE_FILTERS_CLEAR:
		case actionTypes.STORE_STANDARD_FILTERS_CLEAR:
		case actionTypes.STORE_STANDARD_AND_QUERY_FILTERS_CLEAR:
			handleSearchRedirect(action, store)
			break
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_SUCCESS:
			handleGoogleSlideCreationSuccess(action, store)
			break
		case actionTypes.MY_LIBRARY_EDIT_LESSON:
			handleEditLesson(action)
			break
		case actionTypes.GOOGLE_SLIDES_SAVE_AND_GO_TO_NEARPOD:
			handleGoogleSlidesSaveAndGoToNearpod(store)
			break
		case actionTypes.ROUTES_GO_TO_PUBLIC_LIBRARY_ADMIN:
			handleRedirect(store, 'public-library/admin')
			break
		case actionTypes.ROUTES_GO_TO_MY_ACTIVITIES:
			handleRedirect(store, 'library/my-activities')
			break
		case actionTypes.ROUTES_GO_TO_SUB_PLANS:
			handleRedirectToSubPlans(store)
			break
		case actionTypes.ROUTES_GO_TO_MY_LIBRARY:
		case actionTypes.MAIN_TOPBAR_HOME_SELECTED_FAILED:
		case actionTypes.INTERACTIVE_VIDEO_EXIT_SELECTED_CONFIRM_ACCEPTED:
		case actionTypes.SESSION_PREVIEW_EXITED:
			handleRedirect(store, 'library/')
			break
		case actionTypes.ROUTES_GO_TO_CHECKOUT:
			handleRedirectStore(store, viewTypes.APP_CHECKOUT)
			break
		case actionTypes.ROUTES_GO_TO_STORE:
		case actionTypes.MY_LIBRARY_EXPLORE_STORE:
		case actionTypes.ONBOARDING_GUIDE_EXPLORE_LESSONS_CARD_SELECTED:
			handleRedirectStore(store, viewTypes.STORE_LANDING)
			break
		case actionTypes.ROUTES_GO_TO_PRIVATE_LIBRARY:
			handleRedirect(store, `libraries/${action.libraryId}`)
			break
		case actionTypes.ROUTES_GO_TO_REPORTS:
			handleRedirectReport()
			break
		case actionTypes.NAVIGATION_MENU_HELP_TEACHER_RESOURCES_SELECTED:
		case actionTypes.ROUTES_GO_TO_TEACHER_RESOURCES:
			window.open(`${config.www}blog/resources/`, '_blank')
			break
		case actionTypes.NAVIGATION_MENU_HELP_HELP_CENTER_SELECTED:
			window.open('https://nearpod.zendesk.com/hc/en-us', '_blank')
			break
		case actionTypes.FLIPGRID_HELP_SELECTED:
			window.open('https://nearpod.zendesk.com/hc/en-us/articles/360047767551-Using-Flipgrid-within-Nearpod', '_blank')
			break
		case actionTypes.NAVIGATION_MENU_HELP_WHATS_NEW_SELECTED:
			window.open(`${config.www}blog/nearpod-updates/`, '_blank')
			break
		case actionTypes.MAIN_TOPBAR_LOGO_SELECTED:
		case actionTypes.NAVIGATION_MENU_HELP_PERSONALIZED_NEWS_SELECTED:
			handlePersonalizedNewsRedirect(store)
			break
		case actionTypes.GOOGLE_SLIDES_GO_TO_MY_LIBRARY:
			window.open(`${config.www}library/`, '_blank')
			break
		case actionTypes.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRMED:
		case actionTypes.NAVIGATION_MENU_UPGRADE_SELECTED:
			window.open(action.redirectUrl, '_blank')
			break
		case actionTypes.ONBOARDING_ACTIVITY_CREATE_LESSON_FAILED:
		case actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_CANCELLED:
		case actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_SUCCESS:
		case actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_FAILED:
		case actionTypes.MY_LIBRARY_IMMERSIVE_READER_CANCELLED:
		case actionTypes.GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_SUCCESS:
		case actionTypes.GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_FAILED:
		case actionTypes.GOALS_OEQ_CARD_ENABLE_LESSON_SUCCESS:
		case actionTypes.GOALS_OEQ_CARD_ENABLE_LESSON_FAILED:
		case actionTypes.QUICK_LAUNCH_CANCEL_LAUNCH:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_CANCEL_CONFIRMED:
			browserHistory.push('/library/')
			break
		case actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START:
			browserHistory.replace(browserHistory.replace(window.location.pathname))
			break
		case actionTypes.PRIVATE_LIBRARY_SETTINGS_FETCHED:
		case actionTypes.MY_LIBRARY_PREVIEW_INITIALIZE:
		case actionTypes.MY_LIBRARY_INITIALIZE:
		case actionTypes.MY_ACTIVITIES_INITIALIZE:
			handleNotSupportedDevices(store)
			break
		case actionTypes.ONBOARDING_ACTIVITY_CREATE_LESSON_SUCCESS:
		case actionTypes.ONBOARDING_ACTIVITY_CREATE_INITIALIZE:
		case actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_INITIALIZE:
			handleOnboardingActivityView(store)
			break
		case actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON_WITH_DEMO:
		case actionTypes.GOALS_COLLABORATE_CARD_TOOLTIP_SELECTED:
		case actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_COMPLETED:
			browserHistory.push('/onboarding/demo')
			break
		case actionTypes.DEVICE_NOT_SUPPORTED_GO_TO_WEBSITE:
			window.location.href = `${config.www}?ph=1`
			break
		case actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON:
		case actionTypes.ONBOARDING_ACTIVITY_DEMO_COMPLETED:
			browserHistory.push('/onboarding/create')
			break
		case actionTypes.MY_LIBRARY_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED:
		case actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED:
		case actionTypes.STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED:
			handleFrontOfClassroomRedirection(action.payload)
			break
		case actionTypes.FLOCABULARY_LIMIT_REACHED_OVERLAY_NUDGE_SELECTED:
			handleNudgeMyAdminSelected(store, action)
			break
		case actionTypes.BINDERS_INITIALIZE:
			handleNotSupportedDevices(store)
			handleUnauthorizedBinderAccess(store)
			break
		case actionTypes.GOALS_TIME_TO_CLIMB_CARD_CREATE_LESSON:
			window.location.href = `${config.ct_alt}onboarding/timeToClimbSetup`
			break
		case actionTypes.GOALS_OEQ_CARD_CREATE_LESSON_SUCCESS:
			browserHistory.push(`/oeq/create/${action.payload.slideId}?presentationOrigin=${presentationOriginTypes.GOALS}`)
			break
		case actionTypes.OEQ_SAVE_OEQ_SUCCESS:
		case actionTypes.SAVE_ACTIVITY_SUCCESS_REDIRECT:
			handleRedirectSaveActivity(store, action)
			break
		case actionTypes.QUICK_LAUNCH_CREATE_OEQ:
			handleOpenQuickLaunchOeqCreate(store)
			break
		case actionTypes.QUICK_LAUNCH_CREATE_DRAW_IT:
			handleOpenQuickLaunchDrawItCreate(store)
			break
		case actionTypes.QUICK_LAUNCH_TIMER_CREATE:
			handleOpenQuickLaunchTimerCreate(store)
			break
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE:
			handleOpenQuickLaunchCollaborateCreate(store)
			break
		case actionTypes.QUICK_LAUNCH_OEQ_CREATE_LESSON_SUCCESS:
			browserHistory.replace(`/quick-launch/oeq/create/${action.oeqUID}`)
			break
		case actionTypes.QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_SUCCESS:
			browserHistory.replace(`/quick-launch/draw-it/create/${action.drawItUID}`)
			break
		case actionTypes.QUICK_LAUNCH_TIMER_CREATE_SAVE:
			browserHistory.push(`/quick-launch/timer?time=${action.time}`)
			break
		case actionTypes.ADMIN_DASHBOARD_TOOLTIP_ACCEPTED:
			window.location.href = `${config.ct}admin/dashboard.php`
			break
		case actionTypes.QUICK_LAUNCH_TIMER_CANCEL_COUNTDOWN:
		case actionTypes.QUICK_LAUNCH_TIMER_CANCEL_PILL:
			browserHistory.push('/library')
			break
		case actionTypes.NAVIGATION_MENU_MAIN_ACCOUNT_METRICS_SUCCESS:
			handleRedirect(store, 'account')
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATE_SUCCESS:
			handleInteractiveVideoCreation(action)
			break
		case actionTypes.NAVIGATION_MENU_MAIN_LOGOUT_METRICS_SUCCESS:
			window.location.href = `${config.ct}actions/user/logout.php`
			break
		case actionTypes.NAVIGATION_MENU_MAIN_MANAGE_SELECTED:
			handleNavigationMenuMainManage(store, action)
			break
		case actionTypes.INTERACTIVE_VIDEO_ACTIVITY_CREATE_SUCCESS:
			interactiveVideoCreationActivityCreateRedirection(store, action)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY_SUCCESS:
			interactiveVideoCreationActivityEditRedirection(store, action)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_CREATE_SUCCESS:
			interactiveVideoCreationRouteUpdate(store)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_CONFIRMED:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_SUCCESS:
			interactiveVideoCreationRedirectToMediaView(store)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL:
			if (!action.isModified) {
				interactiveVideoCreationRedirectToMediaView(store)
			}
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_CANCEL:
			interactiveVideoCreationCancelRedirect(store)
			break
		case actionTypes.NAVIGATION_MENU_MAIN_SETTINGS_METRICS_SUCCESS:
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_OPEN_SETTINGS:
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_SETTINGS_SELECTED:
			handleRedirect(store, 'account/advanced')
			break
		case actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_SELECTED:
			window.open(`${config.www}unsubscribe`, '_blank')
			break
		case actionTypes.MY_ACCOUNT_PAYMENT_DETAILS_SELECTED:
			window.open(`${config.app}manageAccount`, '_blank')
			break
		case actionTypes.USER_COOKIE_BLOCKED_FAILED:
			handleUserCookieFailed(store, action)
			break
		case actionTypes.GOOGLE_SLIDES_INITIALIZE_UNKNOWN:
			handleGoogleSlidesInitializeError(store, action)
			break
		case actionTypes.USER_COOKIE_BLOCKED_LEARN_MORE:
			handleUserCookieLearnMore(store, action)
			break
		case actionTypes.USER_COOKIE_BLOCKED_RETRY:
			handleUserCookieRetry(store, action)
			break
		case actionTypes.SIGNUP_TEACHER_EMAIL_ALREADY_REGISTERED:
			browserHistory.push('/login')
			break
		case actionTypes.READ_ONLY_NAVIGATE:
			handleReadOnlyNavigation(action)
			break
		case actionTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_UPGRADE_SELECTED:
		case actionTypes.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_UPGRADE_SELECTED: {
			handleRedirectByUrl(
				`${config.www}upgrade-account?utm_source=${action.upgradeSource}&utm_medium=Popup&utm_campaign=Upgrade`
			)
			break
		}
		case actionTypes.USER_SCHOOL_PROFILE_SAVE:
			handleUserSchoolProfileSave(action)
			break
		case actionTypes.VIDEO_PICKER_TAB_SELECTED:
			handleVideoPickerTabSelected(store, action)
			break
		case actionTypes.YOUTUBE_PICKER_UPDATE_SEARCH:
			handleSearchUpdate(action)
			break
		case actionTypes.INTERACTIVE_VIDEO_MEDIA_DATA_FETCHED:
		case actionTypes.INTERACTIVE_VIDEO_GOTO_PICKER:
			handleInteractiveVideoCreationToolRedirection(store)
			break
		case actionTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_UPGRADE_SELECTED:
			handlePaywallsUpgradeSelected(store, action)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE_SUCCESS:
			handleInteractiveVideoSettingsSaveRedirection(store)
			break
		case actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS:
		case actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS:
			handleRedirect(store, 'library/')
			break
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_LIVE_ACTIVE_CODES_SELECTED:
			handleResumeLiveSession(store, action)
			break
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_SUCCESS:
			videoEmbedInSlidesRedirect(store, action)
			break
		case actionTypes.USER_CANNY_IDENTIFY_SUCCESS:
			handleUserCannyIdentifySuccess(action.boardType)
			break
		case actionTypes.PAYWALLS_ADDON_GOOGLE_SLIDES_UPGRADE:
		case actionTypes.PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED:
			redirectToRedeem(action.code)
			break
		case actionTypes.PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED:
			handlePaywallsEditGoogleSlidesUnauthorized()
			break
		case actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SUCCESS:
			handleSessionPreviewRedirect(action)
			break
		case actionTypes.JOIN_SUCCESS:
		case actionTypes.SIGNUP_REFERRAL_SUCCESS:
			handleStudentJoinRedirect(store, action)
			break
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_UPDATED:
			handleActivityUpdated(store, action)
			break
		case actionTypes.STORE_SEARCH_NO_RESULTS_FEEDBACK_SELECTED:
			if (action.variant === variants.FLOCABULARY) {
				window.open(`${config.flocabulary_url}`, '_blank')
			}
			break
		case actionTypes.ACTIVITY_BANKS_CUSTOM_ACTIVITY_UPDATED:
			handleCustomActivityUpdated(store, action)
			break
	}
}

export default redirectMiddleware
